// const ip = 'http://127.0.0.1:8000/'
/*const ip = 'http://61.155.5.241:1123'*/

const get_db = '/zjl/API/glDb/getDb?';
const getDbMacS = '/zjl/API/glDb/getDbMacS?';
const add_db = '/zjl/API/glDb/addDb?';
const change_db = '/zjl/API/glDb/changeDb?';
const del_db = '/zjl/API/glDb/delDb?';
const get_wat = '/zjl/API/glDb/getWat?';
const add_wat = '/zjl/API/glDb/addWat?';
const change_wat = '/zjl/API/glDb/changeWat?';
const del_wat = '/zjl/API/glDb/delWat?';
const configDb = '/zjl/API/glDb/configDb?';
const get_db_xy = '/zjl/API/getTypeDb?';
const changeLightName = '/zjl/tmp/changeName?';

const showDn = '/zjl/API/showDn?';
const getDayDl = '/zjl/API/getDayDl?';
const getMoonDl = '/zjl/API/getMoonDl?';
const getOneLock = '/zjl/API/getOneLock?';
const getManyLock = '/zjl/API/getManyLock?';
const getOneTime = '/zjl/API/getOneTime?';
const getManyTime = '/zjl/API/getManyTime?';
const devCtr = '/zjl/API/devCtr?';
const devManyCtr = '/zjl/API/devManyCtr?';
const getWebMsg = '/zjl/API/getWebMsg?';
const get_dev_list = '/zjl/API/getDevList?';
const getDbDaySum = '/zjl/API/getDbDaySum?'; /*获取电表日数据*/
const getDbMoonSum = '/zjl/API/getDbMoonSum?'; /*获取电表日数据*/
const getDbDayAll = '/zjl/API/getDbDayAll?'; /*获取指定电表日数据*/
const get_log_wg = '/zjl/API/getLogWg?'; /*获取网关状态历史记录*/
const get_log_cz = '/zjl/API/getCzLog?'; /*获取充值历史记录*/
const getCzStop = '/zjl/API/getCzStop?'; /*获取设备停机数据*/
const setCzStop = '/zjl/API/setCzStop?'; /*设置设备停机*/
const getCzLimit = '/zjl/API/getCzLimit?'; /*获取设备停机数据*/
const setCzLimit = '/zjl/API/setCzLimit?'; /*设置设备停机*/
const get_log_dev = '/zjl/API/getLogDev?'; /*获取全部设备控制记录*/
const getLogTemp = '/zjl/API/getLogTemp?'; /*获取环境温度日志*/
const get_log_dev1 = '/zjl/API/getAllLogDev?'; /*初始获取设备记录*/
const get_log_one_dev = '/zjl/API/getLogOneDev?'; /*获取单个设备控制记录*/
const getOnlineWg = '/zjl/API/getOnlineWg?';
const login = '/zjl/API/login?';
const get_wg_cmd = '/zjl/API/getLogCmd?';
const get_wg = '/zjl/API/getWg?';
const add_wg = '/zjl/API/addWg?';
const change_wg = '/zjl/API/changeWg?';
const wgWithArea = '/zjl/API/wgWithArea?';
const gsWithArea = '/zjl/API/gsWithArea?';
const timingWithArea = '/zjl/API/timingWithArea?';
const sceneWithArea = '/zjl/API/sceneWithArea?';
const linkWithArea = '/zjl/API/linkWithArea?';
const del_wg = '/zjl/API/delWg?';

const get_timing = '/zjl/API/getTiming?';
const add_timing = '/zjl/API/addTiming?';
const change_timing = '/zjl/API/changeTiming?';
const del_timing = '/zjl/API/delTiming?';
const get_scene = '/zjl/API/getScene?';
const add_scene = '/zjl/API/addScene?';
const change_scene = '/zjl/API/changeScene?';
const del_scene = '/zjl/API/delScene?';
const run_scene = '/zjl/API/runScene?';
const get_group = '/zjl/API/groupGet?';
const add_group = '/zjl/API/groupAdd?';
const change_group = '/zjl/API/groupChange?';
const del_group = '/zjl/API/groupDel?';
const run_group = '/zjl/API/groupRun?';
const get_link = '/zjl/API/getLink?';
const add_link = '/zjl/API/addLink?';
const change_link = '/zjl/API/changeLink?';
const del_link = '/zjl/API/delLink?';
const run_link = '/zjl/API/runLink?';

const get_gs = '/zjl/API/getGs?';
const add_gs = '/zjl/API/addGs?';
const change_gs = '/zjl/API/changeGs?';
const del_gs = '/zjl/API/delGs?';
const addMoney = '/zjl/API/addMoney?';
const cleanMoney = '/zjl/API/cleanMoney?';
const change_pswd = '/zjl/API/changePwd?';
const changeUser = '/zjl/API/changeUser?';
const get_dev_arg = '/zjl/API/getArg?';
const get_scene_arg = '/zjl/API/getSceneArg?';
const addAct = '/zjl/API/addAct?';
const delAct = '/zjl/API/delAct?';
const getAct = '/zjl/API/getAct?';
const changeAct = '/zjl/API/changeAct?';

const get_dev = '/zjl/API/getDev?';
const change_dev = '/zjl/API/changeDev?';
const add_dev = '/zjl/API/addDev?';
const del_dev = '/zjl/API/delDev?';
const getDlSjXs = '/zjl/API/getDlSjXs?';
const changeDlSjXs = '/zjl/API/changeDlSjXs?';
const setTimeXs = '/zjl/API/setTimeXs?';
const getTimeXs = '/zjl/API/getTimeXs?';

const get_area = '/zjl/API/getArea?';
const getImgUrl = '/zjl/API/getImgUrl?';
const getImgData = '/zjl/API/getImgData?';
const add_area = '/zjl/API/addArea?';
const change_area = '/zjl/API/changeArea?';
const del_area = '/zjl/API/delArea?';
const get_building = '/zjl/API/getBuilding?';
const add_building = '/zjl/API/addBuilding?';
const change_building = '/zjl/API/changeBuilding?';
const del_building = '/zjl/API/delBuilding?';
const get_unit = '/zjl/API/getUnit?';
const add_unit = '/zjl/API/addUnit?';
const change_unit = '/zjl/API/changeUnit?';
const del_unit = '/zjl/API/delUnit?';
const get_max_area = '/zjl/API/getMaxArea?';
const change_max_area = '/zjl/API/changeMaxArea?';
const get_area_list = '/zjl/API/getAreaList?';
const get_floor = '/zjl/API/getFloor?';
const add_floor = '/zjl/API/addFloor?';
const change_floor = '/zjl/API/changeFloor?';
const del_floor = '/zjl/API/delFloor?';
const find_dev = '/zjl/API/findDevList?';

const upTabShow = '/zjl/API/upTabShow?';
const getTabShow = '/zjl/API/getTabShow?';
const getDlDay = '/zjl/API/getDlDay?';
const getDlMoon = '/zjl/API/getDlMoon?';

const getTypeDev = '/zjl/API/getTypeDev?';
const get_room = '/zjl/API/getRoom?';
const add_room = '/zjl/API/addRoom?';
const change_room = '/zjl/API/changeRoom?';
const del_room = '/zjl/API/delRoom?';

const get_usr = '/zjl/API/getUser?';
const add_usr = '/zjl/API/addUser?';
const change_usr = '/zjl/API/changeUser?';
const del_usr = '/zjl/API/delUser?';
const up_img = '/zjl/API/upImg?';
const upTimetable = '/zjl/API/upTimetable?';
const upBuildtable = '/zjl/API/upBuildtable?';
const getBuildtable = '/zjl/API/getBuildtable?';
const getTimetable = '/zjl/API/getTimetable?';
const getDaytable = '/zjl/API/getDaytable?';
const upTabTime = '/zjl/API/upTabTime?';
const getTabTime = '/zjl/API/getTabTime?';
const setWbWith = '/zjl/wb/setWbWith?';
const getWbWith = '/zjl/wb/getWbWith?';

const getProjectInfo = '/platform/project/getProjectInfo';
const updateProjectWxCodeUrl = '/platform/project/updateProjectWxCodeUrl';
const getSysUserList = '/platform/sysuser/getSysUserList';
const getAuthorityList = '/platform/authority/getAuthorityList';
const newSysUser = '/platform/sysuser/newSysUser';
const setSysUserInfo = '/platform/sysuser/setSysUserInfo';
const changePassword = '/platform/sysuser/changePassword';
const deleteSysUser = '/platform/sysuser/deleteSysUser';
const getBuildingList = '/platform/project/getBuildingList';
const getFloorList = '/platform/project/getFloorList';
const getBuildingInfo = '/platform/project/getBuildingInfo';
const addBuilding = '/platform/project/addBuilding';
const addFloor = '/platform/project/addFloor';
const addRoom = '/platform/project/addRoom';
const updateBuilding = '/platform/project/updateBuilding';
const updateFloor = '/platform/project/updateFloor';
const updateRoom = '/platform/project/updateRoom';
const delBuilding = '/platform/project/delBuilding';
const delFloor = '/platform/project/delFloor';
const delRoom = '/platform/project/delRoom';
const setRoomOpenScene = '/platform/project/setRoomOpenScene';
const removeRoomOpenScene = '/platform/project/removeRoomOpenScene';
const setRoomCloseScene = '/platform/project/setRoomCloseScene';
const removeRoomCloseScene = '/platform/project/removeRoomCloseScene';
const getRoomInfo = '/platform/project/getRoomInfo';
const syncRoomScene = '/platform/project/syncRoomScene';
const updateRoomDevice = '/platform/project/updateRoomDevice';
const updateFloorDevice = '/platform/project/updateFloorDevice';
const addRoomUnion = '/platform/project/addRoomUnion';
const delRoomUnion = '/platform/project/delRoomUnion';
const getRoomUnion = '/platform/project/getRoomUnion';
const updateRoomUnion = '/platform/project/updateRoomUnion';
const getRoomUnionList = '/platform/project/getRoomUnionList';
const appendRoom2Union = '/platform/project/appendRoom2Union';
const delRoomFromUnion = '/platform/project/delRoomFromUnion';
const queryGroupList = '/platform/group/queryGroupList';
const deleteGroup = '/platform/group/deleteGroup';
const newGroup = '/platform/group/newGroup';
const updateGroup = '/platform/group/updateGroup';
const addDeviceToGroup = '/platform/group/addDeviceToGroup';
const queryGroup = '/platform/group/queryGroup';
const removeDeviceFromGroup = '/platform/group/removeDeviceFromGroup';

const addZone = '/platform/mj/addZone';
const delZone = '/platform/mj/delZone';
const updateZone = '/platform/mj/updateZone';
const getZone = '/platform/mj/getZone';
const getZoneList = '/platform/mj/getZoneList';
const addZoneArea = '/platform/mj/addZoneArea';
const delZoneArea = '/platform/mj/delZoneArea';
const updateZoneArea = '/platform/mj/updateZoneArea';
const getZoneArea = '/platform/mj/getZoneArea';
const getZoneAreaList = '/platform/mj/getZoneAreaList';
const addZoneBuilding = '/platform/mj/addZoneBuilding';
const delZoneBuilding = '/platform/mj/delZoneBuilding';
const updateZoneBuilding = '/platform/mj/updateZoneBuilding';
const getZoneBuilding = '/platform/mj/getZoneBuilding';
const getZoneBuildingList = '/platform/mj/getZoneBuildingList';
const addZoneUnit = '/platform/mj/addZoneUnit';
const delZoneUnit = '/platform/mj/delZoneUnit';
const updateZoneUnit = '/platform/mj/updateZoneUnit';
const getZoneUnit = '/platform/mj/getZoneUnit';
const getZoneUnitList = '/platform/mj/getZoneUnitList';
const addZoneRoom = '/platform/mj/addZoneRoom';
const addZoneRooms = '/platform/mj/addZoneRooms';
const delZoneRoom = '/platform/mj/delZoneRoom';
const updateZoneRoom = '/platform/mj/updateZoneRoom';
const getZoneRoom = '/platform/mj/getZoneRoom';
const getZoneRoomList = '/platform/mj/getZoneRoomList';

const showOrHideDevice = '/platform/iot/showOrHideDevice';
const getPidArg = '/platform/iot/queryprofile';
const syncBleGatewayState = '/platform/iot/syncBleGatewayState';
const trigQueryDeviceState = '/platform/iot/trigQueryDeviceState';
const queryDevice = '/platform/iot/queryDevice';
const getPidList = '/platform/iot/getPidList';
const getDeviceList = '/platform/iot/getDeviceList';
const getOnlineInfo = '/platform/iot/getOnlineInfo';
const deviceCtrl = '/platform/iot/deviceCtrl';
const groupCtrl = '/platform/group/groupCtrl';
const delDevice = '/platform/iot/delDevice';
const updateDevice = '/platform/iot/updateDevice';
const addDevice = '/platform/iot/addDevice';
const getDeviceStatusList = '/platform/iot/getDeviceStatusList';
const lockAllIndoors = '/platform/iot/lockAllIndoors';
const getVGroupDeviceList = '/platform/iot/getVGroupDeviceList';
const addDevToVGroup = '/platform/iot/addDevToVGroup';
const updateVGroupDevice = '/platform/iot/updateVGroupDevice';

const getTimerList = '/platform/timer/getTimerList';
const addTimer = '/platform/timer/addTimer';
const delTimer = '/platform/timer/delTimer';
const updateTimer = '/platform/timer/updateTimer';
const enableTimer = '/platform/timer/enableTimer';
const getSceneList = '/platform/scene/getSceneList';
const newScene = '/platform/scene/newScene';
const updateScene = '/platform/scene/updateScene';
const replaceSceneItem = '/platform/scene/replaceSceneItem';
const sceneExecute = '/platform/scene/sceneExecute';
const delScene = '/platform/scene/delScene';

const getUserMgrLogList = '/platform/log/getUserMgrLogList';
const getDeviceMgrLogList = '/platform/log/getDeviceMgrLogList';
const getSceneExeLogList = '/platform/log/getSceneExeLogList';
const getTimerMgrLogList = '/platform/log/getTimerMgrLogList';
const today = '/platform/airenergy/today';
const curWeek = '/platform/airenergy/curWeek';
const curMonth = '/platform/airenergy/curMonth';
const curYear = '/platform/airenergy/curYear';

const addAuto = '/platform/auto/addAuto';
const enableAuto = '/platform/auto/enableAuto';
const updateAuto = '/platform/auto/updateAuto';
const getAutoList = '/platform/auto/getAutoList';
const delAuto = '/platform/auto/delAuto';
const getAutoTriggerList = '/platform/auto/getAutoTriggerList';
const addAutoTrigger = '/platform/auto/addAutoTrigger';
const delAutoTrigger = '/platform/auto/delAutoTrigger';
const updateAutoTrigger = '/platform/auto/updateAutoTrigger';
const getAutoConditionList = '/platform/auto/getAutoConditionList';
const addAutoCondition = '/platform/auto/addAutoCondition';
const delAutoCondition = '/platform/auto/delAutoCondition';
const updateAutoCondition = '/platform/auto/updateAutoCondition';
const getAutoExceptionList = '/platform/auto/getAutoExceptionList';
const addAutoException = '/platform/auto/addAutoException';
const delAutoException = '/platform/auto/delAutoException';
const updateAutoException = '/platform/auto/updateAutoException';

const getActivityList = '/platform/service/getActivityList';
const newActivity = '/platform/service/newActivity';
const delActivity = '/platform/service/delActivity';
const changeActivity = '/platform/service/changeActivity';
const updateActivity = '/platform/service/updateActivity';
const addActivityImages = '/platform/service/addActivityImages';
const replaceActivityImages = '/platform/service/replaceActivityImages';
const changeActivityState = '/platform/service/changeActivityState';
const uploadFile = '/platform/file/uploadFile';
const getFeedbackList = '/platform/service/getFeedbackList';
const getFeedbackStatis = '/platform/service/getFeedbackStatis';
const queryFeedback = '/platform/service/queryFeedback';
const processFeedback = '/platform/service/processFeedback';
const getNotifyList = '/platform/service/getNotifyList';
const newNotify = '/platform/service/newNotify';
const delNotify = '/platform/service/delNotify';
const changeNotify = '/platform/service/changeNotify';
const updateNotify = '/platform/service/updateNotify';
const changeNotifyState = '/platform/service/changeNotifyState';
const notifyStatis = '/platform/service/notifyStatis';
const getBannerList = '/platform/service/getBannerList';
const newBanner = '/platform/service/newBanner';
const delBanner = '/platform/service/delBanner';
const updateBannerOrder = '/platform/service/updateBannerOrder';
const exchangeBannerSort = '/platform/service/exchangeBannerSort';
const exchangeNotifySort = '/platform/service/exchangeNotifySort';
const changeBanner = '/platform/service/changeBanner';
const updateBanner = '/platform/service/updateBanner';
const postBanner = '/platform/service/postBanner';
const getRoomList = '/platform/project/getRoomList';
const updateRoomAppointInfo = '/platform/project/updateRoomAppointInfo';
const getAppointTotal = '/platform/service/getAppointTotal';
const getActivityEvaluateList = '/platform/service/getActivityEvaluateList';
const getActivityEvaluateStatis = '/platform/service/getActivityEvaluateStatis';
const getAppointDetailList = '/platform/service/getAppointDetailList';
const getAppointList = '/platform/service/getAppointList';
const getAppointRatio = '/platform/service/getAppointRatio';
const getAppointInOneDay = '/platform/service/getAppointInOneDay';
const getHsUserList = '/platform/mj/getUserList';
const addHsUser = '/platform/mj/addUser';
const upHsdateUser = '/platform/mj/updateUser';
const delHsUser = '/platform/mj/delUser';
const approveUser = '/platform/mj/approveUser';
const getMarketAppointList = '/platform/market/getMarketAppointList';
const getAppointSetting = '/platform/market/getAppointSetting';
const editAppointSetting = '/platform/market/editAppointSetting';
const newAppointSetting = '/platform/market/newAppointSetting';
const newInterestingProduct = '/platform/market/newInterestingProduct';
const newAppointService = '/platform/service/newAppointService';
const editAppointService = '/platform/service/editAppointService';
const delAppointService = '/platform/service/delAppointService';
const getAppointServiceList = '/platform/service/getAppointServiceList';
const newInterestingDrink = '/platform/market/newInterestingDrink';
const delInterestingProduct = '/platform/market/delInterestingProduct';
const delInterestingDrink = '/platform/market/delInterestingDrink';
const changeInterestingProduct = '/platform/market/editInterestingProduct';
const changeInterestingDrink = '/platform/market/editInterestingDrink';
const newInvalidTimeRange = '/platform/market/newInvalidTimeRange';
const editInvalidTimeRange = '/platform/market/editInvalidTimeRange';
const newValidTimeRange = '/platform/market/newValidTimeRange';
const editValidTimeRange = '/platform/market/editValidTimeRange';
const delValidTimeRange = '/platform/market/delValidTimeRange';
const delInvalidTimeRange = '/platform/market/delInvalidTimeRange';
const approveMarketAppoint = '/platform/market/approveMarketAppoint';
const delMarketAppoint = '/platform/market/delMarketAppoint';
const getAppointCareList = '/platform/service/getAppointCareList';
const editAppointCare = '/platform/service/editAppointCare';
const newAppointCare = '/platform/service/newAppointCare';
const delAppointCare = '/platform/service/delAppointCare';
const addAppoint = '/platform/service/addAppoint';
const addAppointBySys = '/platform/service/addAppointBySys';

const getRojectAlgrithm = '/platform/acfee/getRojectAlgrithm';
const setProjectAlgrithm = '/platform/acfee/setProjectAlgrithm';
const getAlgrithmParamList = '/platform/acfee/getAlgrithmParamList';
const getIndoorByAlgParamId = '/platform/acfee/getIndoorByAlgParamId';
const addAlgrithmParam = '/platform/acfee/addAlgrithmParam';
const updateAlgrithmParam = '/platform/acfee/updateAlgrithmParam';
const delAlgrithmParam = '/platform/acfee/delAlgrithmParam';
const getProjectAlgrithm = '/platform/acfee/getProjectAlgrithm';
const setIndoorAlgrithmParam = '/platform/acfee/setIndoorAlgrithmParam';
const clearIndoorAlgrithmParam = '/platform/acfee/clearIndoorAlgrithmParam';
const getElecPriceHourList = '/platform/acfee/getElecPriceHourList';
const addElecPriceHour = '/platform/acfee/addElecPriceHour';
const updateElecPriceHour = '/platform/acfee/updateElecPriceHour';
const delElecPriceHour = '/platform/acfee/delElecPriceHour';
const getEnterpriseList = '/platform/acfee/getEnterpriseList';
const addEnterprise = '/platform/acfee/addEnterprise';
const updateAirEnterprise = '/platform/acfee/updateAirEnterprise';
const chargeMoney = '/platform/acfee/charge';
const terminate = '/platform/acfee/terminate';
const delEnterprise = '/platform/acfee/delEnterprise';
const enableEnterpriseAutoDuction = '/platform/acfee/enableEnterpriseAutoDuction';
const enableEnterpriseAutoStop = '/platform/acfee/enableEnterpriseAutoStop';

export default {
  newGroup:newGroup,
  deleteGroup:deleteGroup,
  queryGroup:queryGroup,
  updateGroup:updateGroup,
  getDeviceList:getDeviceList,
  getBuildingList:getBuildingList,
  removeDeviceFromGroup:removeDeviceFromGroup,
  setSysUserInfo:setSysUserInfo,
  getPidList:getPidList,
  addDeviceToGroup:addDeviceToGroup,
  queryGroupList:queryGroupList,
  getRojectAlgrithm:getRojectAlgrithm,
  setProjectAlgrithm:setProjectAlgrithm,
  getIndoorByAlgParamId:getIndoorByAlgParamId,
  getAlgrithmParamList:getAlgrithmParamList,
  addAlgrithmParam:addAlgrithmParam,
  updateAlgrithmParam:updateAlgrithmParam,
  delAlgrithmParam:delAlgrithmParam,
  getProjectAlgrithm:getProjectAlgrithm,
  setIndoorAlgrithmParam:setIndoorAlgrithmParam,
  clearIndoorAlgrithmParam:clearIndoorAlgrithmParam,
  getElecPriceHourList:getElecPriceHourList,
  addElecPriceHour:addElecPriceHour,
  updateElecPriceHour:updateElecPriceHour,
  delElecPriceHour:delElecPriceHour,
  getEnterpriseList:getEnterpriseList,
  addEnterprise:addEnterprise,
  updateAirEnterprise:updateAirEnterprise,
  chargeMoney:chargeMoney,
  terminate:terminate,
  delEnterprise:delEnterprise,
  enableEnterpriseAutoDuction:enableEnterpriseAutoDuction,
  enableEnterpriseAutoStop:enableEnterpriseAutoStop,

  ip:'http://127.0.0.1:1125',
  webMsg:'ws://127.0.0.1:8806',
  login:login,
  devCtr:devCtr, /*设备控制*/
  devManyCtr:devManyCtr, /*设备群控*/
  getWebMsg:getWebMsg, /*设备群控*/
  change_pswd:change_pswd, /*修改密码*/
  changeUser:changeUser, /*修改用户信息*/
  get_log_one_dev:get_log_one_dev, /*获取历史数据*/

  getDayDl:getDayDl, /*获取电量*/
  getMoonDl:getMoonDl, /*获取月电量*/
  getDbMoonSum:getDbMoonSum, /*获取月电电表电量*/

  showDn:showDn, /*电脑设备数据总览*/
  getOneLock:getOneLock, /*获取一条锁定*/
  getManyLock:getManyLock, /*获取多条锁定*/
  getOneTime:getOneTime, /*获取一条锁定*/
  getManyTime:getManyTime, /*获取多条锁定*/
  get_dev_list:get_dev_list, /*最新设备状态*/
  get_dev_arg:get_dev_arg,
  get_scene_arg:get_scene_arg,
  get_dev:get_dev,
  add_dev:add_dev,
  change_dev:change_dev,
  del_dev:del_dev,
  getDlSjXs:getDlSjXs,
  changeDlSjXs:changeDlSjXs,
  setTimeXs:setTimeXs,
  getTimeXs:getTimeXs,

  find_dev:find_dev, /*网关搜索设备*/
  get_floor:get_floor, /*获取家庭*/
  add_floor:add_floor,
  change_floor:change_floor,
  del_floor:del_floor,
  get_unit:get_unit,
  add_unit:add_unit,
  change_unit:change_unit,
  del_unit:del_unit,
  get_building:get_building,
  add_building:add_building,
  change_building:change_building,
  del_building:del_building,
  get_area:get_area,
  change_max_area:change_max_area,
  get_max_area:get_max_area,
  get_area_list:get_area_list,
  getImgUrl:getImgUrl,
  getImgData:getImgData,
  add_area:add_area,
  change_area:change_area,
  del_area:del_area,

  getDlDay:getDlDay,
  getDlMoon:getDlMoon,
  upTabShow:upTabShow,
  getTabShow:getTabShow,

  getTypeDev:getTypeDev, /*获取设备类型*/
  get_room:get_room, /*获取房间*/
  add_room:add_room,
  change_room:change_room,
  del_room:del_room,

  getCzStop:getCzStop, /*获取停机设备列表*/
  setCzStop:setCzStop, /*设置充值停机*/
  getCzLimit:getCzLimit, /*获取限制设备列表*/
  setCzLimit:setCzLimit, /*设置限制*/
  get_log_cz:get_log_cz, /*获取充值历史*/
  get_log_wg:get_log_wg, /*获取网关状态历史*/
  get_log_dev:get_log_dev, /*获取设备控制历史*/
  getLogTemp:getLogTemp, /*获取环境温度历史*/
  get_log_dev1:get_log_dev1, /*获取设备控制历史*/
  getDbDaySum:getDbDaySum, /*获取电表日数据*/
  getDbDayAll:getDbDayAll, /*获取指定电表日数据*/
  getOnlineWg:getOnlineWg, /*获取ddc状态*/
  get_wg:get_wg, /*获取网关列表*/
  add_wg:add_wg, /*获取网关列表*/
  get_wg_cmd:get_wg_cmd, /*获取网关控制日志*/
  change_wg:change_wg, /*获取网关列表*/
  wgWithArea:wgWithArea, /*网关关联区域*/
  gsWithArea:gsWithArea, /*网关关联区域*/
  timingWithArea:timingWithArea, /*定时关联区域*/
  sceneWithArea:sceneWithArea, /*场景关联区域*/
  linkWithArea:linkWithArea, /*联动关联区域*/
  del_wg:del_wg, /*获取网关列表*/

  get_timing:get_timing, /*获取定时*/
  add_timing:add_timing, /*添加定时*/
  change_timing:change_timing, /*修改定时*/
  del_timing:del_timing, /*删除定时*/
  get_scene:get_scene, /*获取场景*/
  add_scene:add_scene, /*添加场景*/
  change_scene:change_scene, /*修改场景*/
  del_scene:del_scene, /*删除场景*/
  run_scene:run_scene, /*运行场景*/
  get_group:get_group, /*获取群组*/
  add_group:add_group, /*添加群组*/
  change_group:change_group, /*修改群组*/
  del_group:del_group, /*删除群组*/
  run_group:run_group, /*运行群组*/
  addAct:addAct, /*获取触发条件*/
  delAct:delAct, /*删除触发条件*/
  getAct:getAct, /*获取触发条件*/
  changeAct:changeAct, /*修改触发条件*/
  get_link:get_link, /*获取联动*/
  add_link:add_link, /*添加联动*/
  change_link:change_link, /*修改联动*/
  del_link:del_link, /*删除联动*/
  run_link:run_link, /*运行联动*/

  get_gs:get_gs, /*获取公司列表*/
  add_gs:add_gs,
  change_gs:change_gs,
  del_gs:del_gs,
  addMoney:addMoney,
  cleanMoney:cleanMoney,

  get_db:get_db, /*获取电表数据*/
  getDbMacS:getDbMacS, /*获取电表数据*/
  add_db:add_db, /*添加电表*/
  change_db:change_db, /*修改电表*/
  del_db:del_db, /*删除电表*/
  get_db_xy:get_db_xy, /*获取电表协议*/
  get_wat:get_wat, /*获取电表数据*/
  add_wat:add_wat, /*添加电表*/
  change_wat:change_wat, /*修改电表*/
  del_wat:del_wat, /*删除电表*/
  configDb:configDb, /*删除电表*/
  changeLightName:changeLightName, /*修改灯控名称*/

  get_usr:get_usr,
  add_usr:add_usr,
  change_usr:change_usr,
  del_usr:del_usr,

  getWbWith:getWbWith,
  setWbWith:setWbWith,
  up_img:up_img,
  upTimetable:upTimetable,
  upBuildtable:upBuildtable,
  getBuildtable:getBuildtable,
  getTimetable:getTimetable,
  getDaytable:getDaytable,
  upTabTime:upTabTime,
  getTabTime:getTabTime,

  errors:{
    504:"服务器无法连接",404:"服务器无法连接",403:"权限不足，请联管理员",401:"尚未登录，请登录！"
  }
};

// export default ip;



// WEBPACK FOOTER //
// ./src/config/urls.js